import React from "react"
import { generateUuid } from "../../../../shared/utils/socialtravel"
import PhoneNumberFormControl from "../../../components/PhoneNumberFormControl"
import DateSelectControl from "../../../components/DateSelectControl"
import ProductPickupPointInfo from "./ProductPickupPointInfo"

export default class ProductOrderFieldFormRow extends React.Component {
  handleChange(value) {
    const field = this.props.orderedField.product_order_field

    if (field.type === "ProductOrderField::List") {
      value = field.list_options.find(option => option.id == +value)
    }
    if (field.type === "ProductOrderField::Number") {
      value = +value
    }

    this.props.onChange(value)
  }

  handleProductPickupOptionIdChange(id) {
    const field = this.props.orderedField.product_order_field
    this.props.onChange(id ? {
      pickup_point_option_id: +id,
      pickup_point_option: field.pickup_point_options.find(option => option.id === +id),
    } : null)
  }

  handleCustomLocationNameChange(custom_location_name) {
    this.props.onChange({
      ...this.props.orderedField.value,
      custom_location_name,
    })
  }

  formatPrice(price) {
    const field = this.props.orderedField.product_order_field
    return [
      st.formatMoney( st.exchangeMoney(price, this.props.order.customer_conversion_currency) ),
      field.price_type == "price_per_order" && !field.multiply_price_by_nights_count && I18n.t("attributes.x_price_per_order", {x: ""}),
      field.price_type == "price_per_order" && field.multiply_price_by_nights_count && I18n.t("attributes.x_price_per_order_night", {x: ""}),
      field.price_type == "price_per_item" && !field.multiply_price_by_nights_count && I18n.t("attributes.x_price_per_item", {x: ""}),
      field.price_type == "price_per_item" && field.multiply_price_by_nights_count && I18n.t("attributes.x_price_per_item_night", {x: ""}),
      field.price_type == "price_per_person" && !field.multiply_price_by_nights_count && I18n.t("attributes.x_price_per_person", {x: ""}),
      field.price_type == "price_per_person" && field.multiply_price_by_nights_count && I18n.t("attributes.x_price_per_person_night", {x: ""}),
    ].filter(x => !!x).join(" ")
  }

  render() {
    const field = this.props.orderedField.product_order_field
    const inputId = generateUuid()
    const inputName = field.preset_id || field.name
    const currentValue = this.props.orderedField.value
    const showFieldPriceHelp = field.has_pricing && field.type != "ProductOrderField::List" && field.type != "ProductOrderField::PickupPoint"

    return (
      <div className="form-group form-group-checkbox">
        <label className="form-label" htmlFor={inputId}>
          <div>
            {field.frontend_name}
            {field.order_value_required && <span> *</span>}
            {!!field.customer_hint && (
              <div className="help">{field.customer_hint}</div>
            )}
          </div>
          {showFieldPriceHelp && <div className="help">{this.formatPrice(field.price)}</div>}
        </label>
        <div className="form-wrapper">
          {field.type == "ProductOrderField::Text" &&
            <input
              className="form-control"
              type="text"
              id={inputId}
              name={inputName}
              value={currentValue || ""}
              onChange={event => this.handleChange(event.target.value)} />
          }
          {field.type == "ProductOrderField::Email" &&
            <input
              className="form-control"
              type="email"
              id={inputId}
              name={inputName}
              value={currentValue || ""}
              onChange={event => this.handleChange(event.target.value)} />
          }
          {field.type == "ProductOrderField::PhoneNumber" &&
            <PhoneNumberFormControl
              id={inputId}
              name={inputName}
              value={currentValue || ""}
              onChange={this.handleChange.bind(this)} />
          }
          {field.type == "ProductOrderField::Date" &&
            <DateSelectControl
              id={inputId}
              name={inputName}
              value={currentValue || null}
              onChange={this.handleChange.bind(this)} />
          }
          {field.type == "ProductOrderField::BigText" &&
            <textarea
              id={inputId}
              name={inputName}
              className="form-control"
              value={currentValue || ""}
              onChange={event => this.handleChange(event.target.value)}
              rows="3" />
          }
          {field.type == "ProductOrderField::Boolean" &&
            <div className="checkbox">
              <input
                type="checkbox"
                id={inputId}
                name={inputName}
                checked={currentValue || false}
                onChange={event => this.handleChange(event.target.checked)} />
            </div>
          }
          {field.type == "ProductOrderField::Number" &&
            <select
              className="form-control form-control-inline"
              id={inputId}
              name={inputName}
              value={currentValue || field.min_value}
              onChange={event => this.handleChange(+event.target.value)}>
              {__range__(field.min_value, field.max_value, true).map(i =>
                <option key={i} value={i}>{i}</option>
              )}
            </select>
          }
          {field.type == "ProductOrderField::Country" &&
            <select
              className="form-control"
              id={inputId}
              name={inputName}
              value={currentValue || ""}
              onChange={event => this.handleChange(event.target.value || "")}>
              <option value="">- {I18n.t("base.choose").toLowerCase()} -</option>
              {st.COUNTRIES.map(c =>
                <option key={c[0]} value={c[0]}>{c[1]}</option>
              )}
            </select>
          }
          {field.type == "ProductOrderField::List" &&
            <select
              className="form-control"
              id={inputId}
              name={inputName}
              value={(currentValue && currentValue.id) || ""}
              onChange={event => this.handleChange(+event.target.value)}>
              <option value="">- {I18n.t("base.choose").toLowerCase()} -</option>
              {field.list_options.map((list_option) =>
                <option key={list_option.id} value={list_option.id}>
                  {(
                    field.has_pricing
                    ? `${list_option.name} (${this.formatPrice(list_option.price)})`
                    : list_option.name
                  )}
                </option>
              )}
            </select>
          }
          {field.type == "ProductOrderField::PickupPoint" &&
            <div>
              {field.pickup_point_options.length === 1 && !(currentValue && currentValue.pickup_point_option.pickup_point_type === "custom") && (
                <span>{currentValue.pickup_point_option.name} {currentValue.pickup_point_option.price ? `(${this.formatPrice(currentValue.pickup_point_option.price)})` : ""}</span>
              )}
              {field.pickup_point_options.length > 1 && (
                <select
                  className="form-control u-marginBottom"
                  id={inputId}
                  name={inputName}
                  value={(currentValue && currentValue.pickup_point_option_id) || ""}
                  onChange={event => this.handleProductPickupOptionIdChange(+event.target.value)}>
                  <option value="">- {I18n.t("base.choose").toLowerCase()} -</option>
                  {field.pickup_point_options.map((ppo) =>
                    <option key={ppo.id} value={ppo.id}>
                      {ppo.name} {ppo.price ? `(${this.formatPrice(ppo.price)})` : ""}
                    </option>
                  )}
                </select>
              )}
              {currentValue && currentValue.pickup_point_option.pickup_point_type === "custom" && (
                <input
                  className="form-control"
                  type="text"
                  value={currentValue.custom_location_name || ""}
                  onChange={event => this.handleCustomLocationNameChange(event.target.value)} 
                  placeholder={I18n.t("fe.NewOrderProductForm.custom_location_name_placeholder")}
                  />
              )}
              {currentValue && currentValue.pickup_point_option.pickup_point_type === "predefined" && (
                <ProductPickupPointInfo point={currentValue.pickup_point_option.product_pickup_point} showName={false} />
              )}
            </div>
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/components/ProductOrderFieldFormRow.jsx